export const IMPORT_KEYWORDS = 'IMPORT_KEYWORDS';
export const ADD_FOLDER = 'ADD_FOLDER';
export const ASSIGN_KEYWORD_TO_FOLDER = 'ASSIGN_KEYWORD_TO_FOLDER';
export const ASSIGN_MULTIPLE_KEYWORDS_TO_FOLDER = 'ASSIGN_MULTIPLE_KEYWORDS_TO_FOLDER'; // New
export const SET_KEYWORDS = 'SET_KEYWORDS';
export const SET_RAW_IMPORTED_KEYWORDS = 'SET_RAW_IMPORTED_KEYWORDS';

// Action types for keyword status
export const TOGGLE_KEYWORD_ACTIVE = 'TOGGLE_KEYWORD_ACTIVE';
export const MARK_KEYWORD_DELETED = 'MARK_KEYWORD_DELETED';
export const SET_KEYWORD_VISIBILITY_FILTER = 'SET_KEYWORD_VISIBILITY_FILTER';

// Filter Chip Actions
export const ADD_FILTER_CHIP = 'ADD_FILTER_CHIP';
export const REMOVE_FILTER_CHIP = 'REMOVE_FILTER_CHIP';
export const CLEAR_ALL_FILTER_CHIPS = 'CLEAR_ALL_FILTER_CHIPS';

// Action type for saving/restoring state
export const RESTORE_STATE = 'RESTORE_STATE';

// Action type for N-gram match mode
export const SET_NGRAM_MATCH_MODE = 'SET_NGRAM_MATCH_MODE';

// Action types for multi-select
export const SET_SELECTED_KEYWORDS = 'SET_SELECTED_KEYWORDS';
export const TOGGLE_KEYWORD_SELECTION = 'TOGGLE_KEYWORD_SELECTION';
export const RANGE_SELECT_KEYWORDS = 'RANGE_SELECT_KEYWORDS';

// Action type for Super-select mode
export const TOGGLE_SUPER_SELECT_MODE = 'TOGGLE_SUPER_SELECT_MODE';

// Action type for folder expansion
export const TOGGLE_FOLDER_EXPAND = 'TOGGLE_FOLDER_EXPAND';

// Action type for resetting app state
export const RESET_APP_STATE = 'RESET_APP_STATE';

// Action type for specific column filter UI state (min/max values)
export const SET_COLUMN_FILTER = 'SET_COLUMN_FILTER';
